// extracted by mini-css-extract-plugin
export default {"form":"ForgotPassword_form__pW8Mw","form__password":"ForgotPassword_form__password__R57xp","signupText":"ForgotPassword_signupText__2VaGN"};